import { useMemo } from 'react';
import type { TFunction } from 'next-i18next';
import camelCase from 'lodash/camelCase';

import { useActivitiesQuery } from 'src/hooks/__generated__/queries';

const useActivityIdSearch = (search: string, t: TFunction) => {
    const { data: activities } = useActivitiesQuery();

    const activityIds = useMemo(() => {
        if (search.length === 0) {
            return [];
        }

        const translatedActivities =
            activities?.activities?.map((activity) => ({
                id: activity.id,
                name: t(`common:activities.${camelCase(activity.labelKey)}`),
            })) ?? [];

        const matchingActivities = translatedActivities.filter((activity) =>
            activity.name.toLowerCase().includes(search.toLowerCase()),
        );

        const matchingActivityIds = matchingActivities.map((activity) => activity.id);

        return matchingActivityIds;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activities, search]);

    return activityIds;
};

export default useActivityIdSearch;
